import moment from 'moment'

const ptBrFormatDateTime = (date, response) => {
  return date ? moment(date).format('DD/MM/YYYY [às] HH:mm') : response ?? '-'
}

export default ptBrFormatDateTime
